import { load3DLogo } from '../../vendor/index.js';

export default {
  init() {
    /* Script pour le module vidéo avec curseur, preview et ligne élastique */
    $(
      '.module-popup-contact-rh .gform-body .gform_page_fields .gform_fields .evenement .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img'
    ).each(function () {
      import_url_image = $(this).attr('src');
      $(this)
        .parent()
        .css('mask-image', 'url(' + import_url_image + ')');
      $(this)
        .parent()
        .css('background-image', 'none');
    });
    //init 3D logo
    let scene3D;
    var import_url_image;

    MutationObserver =
      window.MutationObserver || window.WebKitMutationObserver;

    var observer = new MutationObserver(function (mutations, observer) {

      $(
        '.module-popup-contact-rh .gform-body .gform_page_fields .gform_fields .evenement .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img'
      ).each(function () {
        import_url_image = $(this).attr('src');
        $(this)
          .parent()
          .css('mask-image', 'url(' + import_url_image + ')');
        $(this)
          .parent()
          .css('background-image', 'none');
      });
    });

    observer.observe(document.getElementsByClassName('popup_rh')[0], {
      subtree: true,
      attributes: true,
    });


    function openPopup() {
      const logoContainer = $('.wrap_popup .logo_3d_common_rh');

      load3DLogo({ container: logoContainer[0], dark: true }).then((scene) => {
        scene3D = scene;
        scene3D.play();
      });

      $('.popup_rh').addClass('open');
      $('html').addClass('popup');
      $('.module-popup-contact-rh').css({ pointerEvents: 'auto' });
      if ($('.module-popup-contact-rh .popup_rh .popup_content').find('.gform_confirmation_wrapper').length !== 0) {
        $('.module-popup-contact .popup_rh .wrap_popup .logo_3d').css('display', 'block');
      }
      if (scene3D && window.matchMedia('(min-width: 1100px)').matches) {
        scene3D.play();
      }
    }

    $('.iconepopup_rh').on('click', openPopup);

    $('.popup_rh .close').on('click', function () {
      const formId = document.querySelector('.popup_content').getAttribute('data-formId')

      $('.popup_rh').removeClass('open');
      $('html').removeClass('popup');
      $('.module-popup-contact-rh').css({ pointerEvents: 'none' });

      if (scene3D) {
        scene3D.pause();
      }
    });

    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
      $(
        '.popup_rh .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last'
      ).each(function () {
        $(this).append('<span class="focus-border"></span>');
      });

      $(
        '.popup_rh .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input'
      ).each(function () {
        $(this).focusout(function () {
          if ($(this).val() != '') {
            $(this).addClass('has-content');
          } else {
            $(this).removeClass('has-content');
            $(this).val('');
          }
        });
      });

      $(
        '.popup_rh .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .popup_rh .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input'
      ).each(function () {
        if ($(this).val() != '') {
          $(this).addClass('has-content');
        } else {
          $(this).removeClass('has-content');
          $(this).val('');
        }
      });

      $(
        '.popup_rh .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
      ).each(function () {
        $(this).next().append($(this));
      });

      $('.popup_rh .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible .ginput_container_textarea').append(function () {
        var label_inside = $('.popup_rh .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible label.gfield_label');
        return label_inside;
      });

    });
  },
};
